<template>
  <div class="row relative">

    <template v-if="!loading">
      <template v-if="playlist.length">
        <VideoItem class="col-12 col-xs-12 col-sm-6 col-md-6 col-mlg-4 mt-3 mb-sm-4" :item="item" direction="verticle" v-for="(item, ind) in playlist" :key="ind" @watch="onWatch" />
      </template>
      <template v-else>
        <GpEmptyPage page="videoTutorial" />
      </template>
    </template>
    <template v-else>
      <VideoItem class="col-12 col-xs-12 col-sm-6 col-md-6 col-mlg-4 mt-3 mb-sm-4" direction="verticle" v-for="ind in 6" :key="ind" />
    </template>

  </div>
</template>

<script>
import { VideoItem } from "../../components";
import { mapState } from 'vuex';
import GpEmptyPage from "@/core/shared/GpEmptyPage";
export default {
  name: "TopicOverview",
  components: {
    VideoItem,
    GpEmptyPage
  },
  props: {
    topic: Object,
    playlist: Array
  },
  computed: {
    ...mapState({
      loading: state => state.tutorial.loading
    })
  },
  methods: {
    onWatch(item) {
      this.$emit("watch", item);
    }
  }
};
</script>

<style lang="scss" scoped>
.relative {
    min-height: 290px;
}
</style>
